import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-navy border-t border-white/10 py-12 px-6" data-id="element-88">
      <div className="max-w-3xl mx-auto text-center" data-id="element-89">
        <p className="text-white font-heading font-bold text-lg mb-6" data-id="element-90">
          The Reverse-Scroll Method
        </p>

        <div className="space-y-4" data-id="element-91">
          <p className="text-xs text-gray-500 leading-relaxed max-w-2xl mx-auto" data-id="element-92">
            <strong className="text-gray-400" data-id="element-93">Earnings Disclaimer:</strong> The
            income figures mentioned on this page are examples only and are not
            guarantees of earnings. Individual results will vary based on
            effort, market conditions, and other factors. This product provides
            education and guidance — your teen's success depends on their
            initiative and execution.
          </p>

          <p className="text-xs text-gray-500 leading-relaxed max-w-2xl mx-auto" data-id="element-94">
            <strong className="text-gray-400" data-id="element-95">No Professional Advice:</strong>{' '}
            This guide is for educational purposes only and does not constitute
            business, legal, tax, or financial advice. Consult a qualified
            professional for advice specific to your situation.
          </p>

          <p className="text-xs text-gray-500 leading-relaxed max-w-2xl mx-auto" data-id="element-96">
            This product is a digital download (PDF). All sales are final. By
            purchasing, you agree to our Terms of Service and Privacy Policy.
          </p>
        </div>

        <p className="text-xs text-gray-600 mt-8" data-id="element-97">
          © {currentYear} The Reverse-Scroll Method. All rights reserved. First
          Edition.
        </p>
      </div>
    </footer>;
}